export default __webpack_public_path__ + "static/media/contractCommission.388df7d2.svg";